import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { downloadSingleFile } from "../utils/helpers";

// URL de détail selon l'espace de l'utilisateur et le type d'objet
const ROUTES_DETAIL = {
  admin: {
    dossier: (id) => `/admin/dossiers/show/${id}`,
  },
  acteur: {
    dossier: (id) => `/parties/dossiersacteurs/show/${id}`,
  },
};

const UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

// Construit l'URL du front à partir du lien envoyé par le backend
const construireLien = (data, espace) => {
  const id = data.lien?.match(UUID_REGEX)?.[0];
  const route = ROUTES_DETAIL[espace]?.[data.objet_type];
  return id && route ? route(id) : null;
};

export default function NotificationDetailModal({ notification, onHide, espace = "admin" }) {
  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate();

  const data = notification?.data ?? {};
  const fichiers = data.fichiers ?? [];

  const lienFront = construireLien(data, espace);

  const allerVersObjet = () => {
    if (!lienFront) return;
    onHide();
    navigate(lienFront);
  };

  return (
    <Dialog
      header="Notification"
      visible={!!notification}
      onHide={onHide}
      style={{ width: "600px", color: "GrayText" }}
      headerStyle={{ background: "#f0f0f0" }}
      breakpoints={{ "768px": "95vw" }}
    >
      {notification && (
        <>
          <div className="mt-2 mb-3">
            <div className="text-muted small mb-1">Objet</div>
            <h3 className="h5 mb-3">{data.titre || "Sans objet"}</h3>
            <div className="d-flex flex-wrap gap-3 align-items-center text-muted small">
              <span className="badge bg-info text-dark">{notification.module_label}</span>
              <span>
                <i className="bi bi-calendar3 me-1"></i>
                Le {dayjs(notification.created_at).format("DD/MM/YYYY [à] HH:mm")}
              </span>
              {data.auteur && (
                <span>
                  <i className="bi bi-person me-1"></i>
                  {data.auteur.nom}
                  {data.auteur.profil && ` (${data.auteur.profil})`}
                </span>
              )}
            </div>
          </div>

          {/* {data.reference && (
            <p className="mb-2">
              <span className="fw-bold">Référence :</span> {data.reference}
            </p>
          )} */}

          <hr />
          <div className="mb-3">
            <div className="text-muted small mb-2">Message</div>
            <p style={{ whiteSpace: "pre-line", color: "#333" }}>
              {data.message || "Aucun contenu."}
            </p>
          </div>

          {fichiers.length > 0 && (
            <>
              <hr />
              <p className="fw-bold mb-2">
                <i className="bi bi-paperclip me-1"></i>
                Fichiers joints ({fichiers.length})
              </p>
              <ul className="list-group mb-2">
                {fichiers.map((fichier, index) => (
                  <li
                    key={index}
                    className="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <span>
                      <i className="bi bi-file-earmark-text me-2"></i>
                      {fichier.nom}
                    </span>
                    <Button
                      size="sm"
                      variant="outline-primary"
                      title="Télécharger"
                      onClick={() => downloadSingleFile(fichier.path, token)}
                    >
                      <i className="bi bi-download"></i>
                    </Button>
                  </li>
                ))}
              </ul>
            </>
          )}

          <div className="mt-4">
            {lienFront && (
              <Button variant="warning" className="me-3" onClick={allerVersObjet}>
                <i className="bi bi-box-arrow-up-right me-1"></i>
                Voir le dossier
              </Button>
            )}
            <Button variant="secondary" onClick={onHide}>
              Fermer
            </Button>
          </div>
        </>
      )}
    </Dialog>
  );
}